<template>
  <div class="loader-container d-flex justify-center align-center flex-grow-1">
    <v-progress-circular :size="size" :width="width" indeterminate bg-color="transparent" :class="forceVisibility ? 'v-progress-circular--visible' : null" />
  </div>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      default: "md",
      validator: (value) => ["xs", "sm", "md"].includes(value)
    },
    forceVisibility: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    size() {
      switch (this.mode) {
        case "md":
          return 40
        case "sm":
          return 24
      }

      return 16
    },
    width() {
      switch (this.mode) {
        case "md":
          return 4
        case "sm":
          return 2
      }

      return 1
    }
  }
}
</script>
